import type { JSX } from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Input } from '@artosera/ui';
import { JobsTable } from '../components/JobsTable.js';
import pageStyles from '../styles/page.module.css';
import tableStyles from '../styles/table.module.css';

export function JobsGlobal(): JSX.Element {
  const { t } = useTranslation('console');
  const [galerie, setGalerie] = useState('');

  return (
    <section>
      <div className={pageStyles.entete}>
        <div>
          <h1>{t('travaux.titre')}</h1>
          <p>{t('travaux.texte')}</p>
        </div>
      </div>
      <div className={tableStyles.toolbar}>
        <div className={tableStyles.champFiltre}>
          <label htmlFor="travaux-filtre-galerie">{t('travaux.filtreGalerie')}</label>
          <Input
            id="travaux-filtre-galerie"
            value={galerie}
            onChange={(event) => setGalerie(event.target.value)}
          />
        </div>
      </div>
      <JobsTable galerie={galerie.trim() || undefined} />
    </section>
  );
}
